/**
 * @file location-page
 * @author
 */
import React from 'react';
import {connect} from 'react-redux';

import {withRouter} from 'react-router-dom';
import imgBanner from '../normalLandPage/imgs/banner.png';
import CustomButton from '../../components/CustomButton/index';
import LocationResult from '../../components/LocationResult/index';
import {getUrlValue, recordProxy} from '../../util';

import {
    setLocSelect,
    setUserPosition,
    getAreaData,
    getLocationResult,
    setUserPoint
} from '../../actions/locationPage';

import './index.less';

interface IProps {
    history: {
        push: (router: string) => void;
    };
}
type JumpType = 'attest';
export class LocationPage extends React.Component<IProps, any> {
    constructor(prop: IProps) {
        super(prop);
        const tag = getUrlValue('tag') ? decodeURIComponent(getUrlValue('tag')) : '';
        this.state = {
            type: false,
            formData: {},
            status: 1,
            modTop: 290,
            checkboxValue: false,
            tag
        };
    }

    jump = (type: JumpType) => {
        let routerPath = '';
        const aa = {
            type: 'attest-btn'
        };
        recordProxy('location-page', 'click', JSON.stringify(aa));

        switch (type) {
            case 'attest':
                routerPath = '/attest';
                break;
            default:
        }
        routerPath && this.props.history.push(routerPath);
    };
    render() {
        const {tag} = this.state;
        return (<div className="page-normal-land-page location-page">
            <div className="banner-wrapper" onClick={() => this.jump('attest')}>
                <img src={imgBanner} className="banner"></img>
                <div className="content">
                    <p className="title">企业号码认证</p>
                    <p className="tip">官方标识更权威，用户更信任</p>
                    <div className="banner-btn-wrap">
                        <CustomButton
                            type="default"
                            className="banner-btn"
                        >
                            去了解更多
                        </CustomButton>
                        <span className="btn-tip">仅企业用户可认证</span>
                    </div>
                </div>
            </div>
            {tag && <LocationResult pageType="location-page" />}
        </div>);
    }
}

function mapStateToProps(state: any) {
    return {
        userInfo: state.userInfo
    };
}
function mapDispatchToProps(dispatch: Function) {
    return {
        setLocSelect: (obj: any) => setLocSelect(dispatch, obj),
        setUserPosition: (obj: any) => setUserPosition(dispatch, obj),
        setUserPoint: (obj: any) => setUserPoint(dispatch, obj),
        getAreaData: (obj: any) => getAreaData(dispatch, obj),
        getLocationResult: (obj: any) => getLocationResult(dispatch, obj)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter<any, any>(LocationPage));
